// extracted by mini-css-extract-plugin
var _1 = "SubMenuItem-moduleSubMenuItem__JZO6G";
var _2 = "SubMenuItem-moduleactive__Uoeuq";
var _3 = "SubMenuItem-modulecounter__ntYe2";
var _4 = "SubMenuItem-modulelabel__qmP7w";
export { _1 as "SubMenuItem", _2 as "active", _3 as "counter", _4 as "label" }
